import { render } from "./DocumentsBrowserWireframe.vue?vue&type=template&id=5f56643a&scoped=true"
const script = {}

import "./DocumentsBrowserWireframe.vue?vue&type=style&index=0&id=5f56643a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f56643a"]])

export default __exports__